/** 帮助中心 */
import { fetch } from '../request'
import type { IDataBasic, IResponse, Loose } from '../interface'

export interface IApply extends IDataBasic {
  channel_id: number | string
  code: string
  is_new_user: false
  organization_id: number
  project_name: string
  submit_time: string
  user_id: number
  vote_count: number
}
export const reqGetApply = (activity_random_id: string) =>
  fetch<IResponse<IApply[]>>('/ppt_activity_center/apply/', {
    params: { many: 1, activity_random_id },
  })

export interface IChannel extends IDataBasic {
  code: string
  deleted_time: string
  description: string
  is_deleted: boolean
  h5_link: string
  pc_link: string
  title: string
}
export const reqGetChannel = (activity_random_id: string) =>
  fetch<IResponse<IChannel[]>>('/ppt_activity_center/channel/', {
    params: { many: 1, activity_random_id },
  })
export const reqPostApply = (data: Loose) =>
  fetch('/ppt_activity_center/apply/', {
    method: 'POST',
    credential: true,
    body: data,
  })

export const reqPostLandingPageVisit = (data: Loose) =>
  fetch('/ppt_activity_center/landing_page_visit/', {
    method: 'POST',
    credential: true,
    body: data,
  })

// export const reqGetApplyCoins = () =>
//   fetch('/order/apply_coins/', {
//     params: { many: 1, apply_type: 0 },
//   })
